import { GoogleAuthProvider, OAuthProvider, signInWithPopup } from 'firebase/auth';
import { getFirebaseAuth, isFirebaseConfigured } from './firebase';
import type { AuthorizationDecision } from './nexus';

export type Provider = 'google' | 'microsoft';

export type HubUser = {
  name: string;
  firstName: string;
  initials: string;
  email: string | null;
  photoUrl: string | null;
};

const initials = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('') || '?';

export function deriveHubUser(decision: AuthorizationDecision): HubUser {
  const name = decision.display_name ?? decision.email ?? 'Signed-in user';
  const firstName = name.split(/\s+/)[0] ?? name;
  return {
    name,
    firstName,
    initials: initials(name),
    email: decision.email,
    photoUrl: decision.profile?.photo_url ?? null,
  };
}

export async function signInWith(provider: Provider): Promise<void> {
  if (!isFirebaseConfigured) {
    throw new Error('Firebase is not configured. Copy .env.example to .env.local.');
  }
  const auth = getFirebaseAuth();
  const authProvider =
    provider === 'google'
      ? new GoogleAuthProvider()
      : (() => {
          const p = new OAuthProvider('microsoft.com');
          p.setCustomParameters({ tenant: import.meta.env.VITE_MS_TENANT || 'common' });
          return p;
        })();
  await signInWithPopup(auth, authProvider);
}
